import { DashboardModule, Form, Grid } from '@domain-group/suit-theme'

import type { AgencyModel } from '@models/types'

interface PrincipalDetailsProps {
  agencySalesforceDetails: AgencyModel['salesforce_details'],
}

const PrincipalDetails = (props: PrincipalDetailsProps) => {
  const { agencySalesforceDetails } = props

  const principalDetailsPayload = [
    { label: 'Principal Name', value: agencySalesforceDetails?.principal_name },
    { label: 'Principal Email', value: agencySalesforceDetails?.principal_email },
    { label: 'Principal Mobile', value: agencySalesforceDetails?.principal_mobile },
  ]

  return (
    <DashboardModule title="Principal Contact">
      <Grid
        // @ts-expect-error TS2322
        gridGap="large"
        gridTemplateColumns={[
          'repeat(1, minmax(160px, 1fr))',
          'repeat(1, minmax(160px, 1fr))',
          'repeat(1, minmax(160px, 1fr))',
          'repeat(2, minmax(160px, 1fr))',
        ]}
        padding="large"
      >
        {principalDetailsPayload.map(field => (
          <Form.Field label={field.label}>
            <input
              disabled
              type="text"
              value={field.value}
            />
          </Form.Field>
        ))}
      </Grid>
    </DashboardModule>
  )
}

export default PrincipalDetails
